// ---------------------------------------------------------------------------
// Coming Soon feature roadmap — single source of truth.
//
// These features DO NOT exist yet. Every place in the codebase that surfaces
// them must clearly label them "Coming Soon" and never imply they work today.
//
// Nothing here calls any backend API, mutates billing, or enables any
// functionality. This module is display metadata only.
// ---------------------------------------------------------------------------

import { Mail, Search, Megaphone, MessageSquare, Video, ListChecks } from "lucide-react";

export const COMING_SOON_FEATURES = [
  {
    id: "email-marketing",
    name: "Email Marketing",
    icon: Mail,
    short:
      "Create and manage AI-assisted email marketing campaigns for your business from Postmoro.",
    plans: ["pro", "business"],
    planLabel: "Pro & Business",
  },
  {
    id: "competitor-analysis",
    name: "Competitor Analysis",
    icon: Search,
    short:
      "Get detailed AI-powered breakdowns of competitors — their strengths, weaknesses, and where your business can win.",
    plans: ["business"],
    planLabel: "Business",
  },
  {
    id: "ai-ad-creation",
    name: "Ad Creations",
    icon: Megaphone,
    short:
      "Create campaign-ready ad concepts, copy, and creative ideas from your Postmoro workspace.",
    plans: ["pro", "business"],
    planLabel: "Pro & Business",
  },
  {
    id: "ai-dm-bot",
    name: "AI DM Bot / Community Management",
    icon: MessageSquare,
    short:
      "Manage incoming DMs and comments in one place, with AI-assisted responses so community interactions across your connected accounts don't get missed.",
    plans: ["pro", "business"],
    planLabel: "Pro & Business",
  },
  {
    id: "ai-video-creation",
    name: "AI Video Creation",
    icon: Video,
    short:
      "Create AI-assisted video content for social media and marketing campaigns directly in Postmoro.",
    plans: ["pro", "business"],
    planLabel: "Pro & Business",
  },
  {
    id: "task-calendar-management",
    name: "Task & Calendar Management",
    icon: ListChecks,
    short:
      "Organize your business to-do list, prioritize tasks, set deadlines, and manage upcoming work directly in Postmoro. Tasks will connect with your calendar and support reminders so important work doesn't get missed.",
    plans: ["pro", "business"],
    planLabel: "Pro & Business",
  },
];

// Per-plan list of Coming Soon feature labels for pricing tables.
// Each entry is what a pricing bullet should read as (already includes the
// "— Coming Soon" suffix so callers can't accidentally drop the marker).
export const COMING_SOON_BY_PLAN = {
  free: [],
  starter: [],
  pro: [
    "Email Marketing — Coming Soon",
    "Ad Creations — Coming Soon",
    "AI DM Bot / Community Management — Coming Soon",
    "AI Video Creation — Coming Soon",
    "Task & Calendar Management — Coming Soon",
  ],
  business: [
    "Email Marketing — Coming Soon",
    "Competitor Analysis — Coming Soon",
    "Ad Creations — Coming Soon",
    "AI DM Bot / Community Management — Coming Soon",
    "AI Video Creation — Coming Soon",
    "Task & Calendar Management — Coming Soon",
  ],
};
